import { CLEAR_NETWORK_GROUP_SEARCH } from 'actions';

export default function clearNetworkGroupSearch() {
  return (dispatch) => dispatch({ type: CLEAR_NETWORK_GROUP_SEARCH });
}
